

















































































































































































































































































































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {InputText} from '@simpli/vue-input'
import {$} from '@/facade'
import {OrbitProject} from '@/model/resource/OrbitProject'
import {ContractCollection} from '@/model/collection/ContractCollection'
import {OrbitNetworkHelper} from '@/helpers/OrbitNetworkHelper'
import {Contract} from '@/model/resource/Contract'
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue'
import {BlockchainVersion} from '@/model/resource/BlockchainVersion'
import {BlockchainVersionCollection} from '@/model/collection/BlockchainVersionCollection'
import {TokenPriced} from '@/model/resource/TokenPriced'
import {TokenPricedCollection} from '@/model/collection/TokenPricedCollection'
import {PropType} from 'vue'
import OrbitAmountInput from '@/components/orbit/OrbitAmountInput.vue'

@Component({
  components: {
    OrbitAmountInput,
    InputText,
    VueMultiselect,
  },
  computed: {
    $() {
      return $
    },
  },
})
export default class OrbitEditProjectFormStep extends Vue {
  @Prop({type: Object as PropType<OrbitProject | null>})
  orbitProject!: OrbitProject | null

  blockchainVersionCollection = new BlockchainVersionCollection()
  contractCollection = new ContractCollection()
  tokenPricedCollection = new TokenPricedCollection()

  contractOptions: Contract[] = []
  tokenPricedOption: TokenPriced[] = []

  selectedAmount: string | null = null
  selectedBlockchain: BlockchainVersion | null = null
  selectedContract: Contract | null = null
  selectedTokenPriced: TokenPriced | null = null
  eventNames: string | null = null

  get isReviewStepAllowed() {
    return (
      this.selectedContract !== null &&
      this.selectedTokenPriced !== null &&
      this.selectedAmount !== null &&
      this.selectedAmount !== '' &&
      this.selectedBlockchain !== null
    )
  }

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    await this.$await.init('populateResources')

    await this.blockchainVersionCollection.expand()

    this.contractCollection = new ContractCollection()
    this.tokenPricedCollection = new TokenPricedCollection()

    this.contractCollection.limit = 9999
    this.tokenPricedCollection.limit = 9999

    await Promise.all([
      this.contractCollection.expand(),
      this.tokenPricedCollection.expand(),
    ])

    this.contractOptions = this.contractCollection.items
    this.tokenPricedOption = this.tokenPricedCollection.items

    this.selectedAmount = String(
      Number(this.orbitProject?.amount ?? 0) /
        10 ** Number(this.orbitProject?.tokenPriced?.decimals ?? 0)
    )

    this.selectedBlockchain =
      this.blockchainVersionCollection.items.find(
        b =>
          b.idBlockchainVersionPk ===
          this.orbitProject?.blockchainVersion?.idBlockchainVersionPk
      ) || null

    this.selectedContract =
      this.contractOptions.find(
        c => c.idContractPk === this.orbitProject?.contract?.idContractPk
      ) || null

    this.selectedTokenPriced =
      this.tokenPricedOption.find(
        t =>
          t.idTokenPricedPk === this.orbitProject?.tokenPriced?.idTokenPricedPk
      ) || null

    this.eventNames = this.orbitProject?.eventNames ?? null

    await this.$await.done('populateResources')
  }

  async populateFinalResources() {
    this.contractOptions = []
    this.tokenPricedOption = []

    const network = this.selectedBlockchain?.networkIdentifier

    if (!network) return

    await this.$await.run('populateFinalResources', async () => {
      const [contracts, tokens] = await Promise.all([
        OrbitNetworkHelper.contractOptionsOf(network),
        OrbitNetworkHelper.paymentTokenOptionsOf(network),
      ])

      this.contractOptions = contracts
      this.tokenPricedOption = tokens
    })
  }

  async handleChangeSelectedBlockchainInput(val: BlockchainVersion) {
    this.selectedBlockchain = val

    await this.populateFinalResources()
  }

  handleChangeSelectedContractInput(val: Contract) {
    this.selectedContract = val
  }

  handleChangeSelectedTokenPricedInput(val: TokenPriced) {
    this.selectedTokenPriced = val
  }

  handleInputAmount(val: string) {
    this.selectedAmount = val
  }

  clearFields() {
    this.selectedAmount = null
    this.selectedBlockchain = null
    this.selectedContract = null
    this.selectedTokenPriced = null
    this.eventNames = null
  }

  goToNextStep() {
    const deepClonedObject: OrbitProject = new OrbitProject().assign({
      ...this.orbitProject,
    })

    const formattedAmount =
      (Number(this.selectedAmount) ?? 0) *
      10 ** (this.selectedTokenPriced?.decimals ?? 0)

    deepClonedObject.amount = formattedAmount
    deepClonedObject.blockchainVersion = this.selectedBlockchain
    deepClonedObject.contract = this.selectedContract
    deepClonedObject.tokenPriced = this.selectedTokenPriced
    deepClonedObject.eventNames = this.eventNames?.trim() || null

    this.$emit('next-step', deepClonedObject)
  }

  copyToClipboard(address: string) {
    this.$utils.copyToClipboard(address)
    this.$toast.info('system.info.copiedToClipboard')
  }

  closeModal() {
    this.clearFields()
    this.$emit('close')
  }
}
